module.exports = __webpack_public_path__ + "static/img/07.53e3172.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour2/07.jpg
// module id = Jkjp
// module chunks = 0